import ObjArrUtils from '@/utils/ObjArrUtils'
import { Base } from '@/store/base/module'
import moment from 'moment'


const C21101T3010ChatroomCheckModule = {
  state: {
    C21101_t3010ChatroomCheck_output: {
      rows: []
    },
    C21101_t3010ChatroomCheck_nextRefreshTime: null,
  },
  getters: {
    C21101_t3010ChatroomCheck_getData(state) {
      return state.C21101_getStudentSchedule_output.map(item => {
        return {
          rel_id: item.id
        }
      })
    },
    C21101_t3010ChatroomCheck_getMessageCount: (state) => (id) => {
      if(!state.C21101_t3010ChatroomCheck_output.rows || !Array.isArray(state.C21101_t3010ChatroomCheck_output.rows)) {
        return 0;
      }
      const item = state.C21101_t3010ChatroomCheck_output.rows.find(item => item.rel_id === id);
      if (item)
        return item.message_count || 0;

      return 0;
    }
  },
  actions: {
    async C21101_t3010ChatroomCheck({ state, commit,getters }, payload) {
      if (!state.C21101_t3010ChatroomCheck_nextRefreshTime)
        return

      // console.debug('C21101_t3010ChatroomCheck next', moment.duration(state.C21101_t3010ChatroomCheck_nextRefreshTime.diff()).seconds());
      if (moment() < moment(state.C21101_t3010ChatroomCheck_nextRefreshTime)) {
        return;
      }
      commit('setState', {
        C21101_t3010ChatroomCheck_nextRefreshTime: null,
      });
      await $this.$api.postData({
        data: {
          C21101_t3010ChatroomCheck: {
            api: 'X0001ChatService.C21101_t3010ChatroomCheck',
            input:{
              rel_model: 't3010',
              rel_ids: getters.C21101_t3010ChatroomCheck_getData,
            }
          }
        }
      },false).then((data) => {
        commit('setState', {
          C21101_t3010ChatroomCheck_output: data.C21101_t3010ChatroomCheck.output,
          C21101_t3010ChatroomCheck_nextRefreshTime: moment().add(60, 'seconds'),
        })
      })
    }
  }
}

const module = {
  state: {
    C21101_SHOW_ZOOM_INFO: false,
    MEETING_PLATFORM: 'ZOOM',
    C21101_getStudentSchedule_output: [],
    C21101_getStudentSchedule_input:{
      student_no: 1,
      schedule_date: moment().format('YYYY-MM-DD')
    },
  },

  getters: {
  },
  mutations: {
  },
  actions: {
    async C21101_getStudentSchedule({ state, commit }, payload) {
      return await $this.$api.postData({
        data: {
          C21101_SHOW_ZOOM_INFO:{
            api: 'AuthService.getConfig',
            input: {key:'app.C21101_SHOW_ZOOM_INFO'}
          },
          MEETING_PLATFORM:{
            api: 'AuthService.getConfig',
            input: {key:'app.MEETING_PLATFORM'}
          },
          C21101_getStudentSchedule: {
            api: 'T3010ScheduleService.C21101_getStudentSchedule',
            input: state.C21101_getStudentSchedule_input
          }
        }
      }).then((data) => {
        commit('setState', {
          C21101_SHOW_ZOOM_INFO: data.C21101_SHOW_ZOOM_INFO.output,
          MEETING_PLATFORM: data.MEETING_PLATFORM.output,
          C21101_getStudentSchedule_output: data.C21101_getStudentSchedule.output,
          C21101_t3010ChatroomCheck_nextRefreshTime: moment().add(1, 'seconds'),
        })
      })
    }
  }
}

export default ObjArrUtils.merge(Base, module, C21101T3010ChatroomCheckModule)
